import { CanActivateFn, CanMatchFn } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { AuthNavigationService } from '../app/services/auth-navigation.service';

export const privateOnlyCanMatch: CanMatchFn = () => {
  const navigationService = inject(AuthNavigationService);
  return navigationService
    .ensurePrivate$()
    .pipe(
      map((ok) =>
        ok ? true : navigationService.getUrlToRedirect('/internal/sign-in')
      )
    );
};

export const privateOnlyCanActivate: CanActivateFn = () => {
  const navigationService = inject(AuthNavigationService);
  return navigationService
    .ensurePrivate$()
    .pipe(
      map((ok) =>
        ok ? true : navigationService.getUrlToRedirect('/internal/sign-in')
      )
    );
};
